import React, { useEffect, useState } from "react";
import { FaTimes } from "react-icons/fa";
import appRoutes from "../../Routes/appRoutes";
import SidebarItem from "./SidebarItem";
import SidebarItemCollapse from "./SidebarItemCollapse";
import "./sidebar.css";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { Navigate, useNavigate } from "react-router-dom";
function App({ isOpen, toggleSidebar }) {
  const navigate = useNavigate();
  const sidebarWidth = isOpen ? "w-72" : "w-0"; // Adjust sidebar width
  const { t } = useTranslation();
  const user = useSelector((state) => state?.user);
  const [data, setData] = useState([]);

  useEffect(() => {
    if (user?.role === "moderator") {
      navigate("/reports/allreports");
      setData(appRoutes.filter((v) => v?.state === "reports"));
    } else {
      setData(appRoutes.filter((v) => v?.state !== "reports"));
    }
  }, [appRoutes]);
  return (
    <div className="flex  flex-col bg-greeen-400">
      <div
        className={`h-screen bg-gray-800 ${sidebarWidth} text-white  ${
          isOpen ? "translate-x-0" : "-translate-x-full"
        } transition-transform duration-300 ease-in-out transform`}
      >
        <div style={{ height: "16vh" }} className="">
          <div className=" h-12 justify-end flex">
            <FaTimes
              size={20}
              onClick={() => toggleSidebar()}
              className="mt-5 mx-5 cursor-pointer"
            />
          </div>
        </div>

        <div className="mt-3 overflow-y-auto 	" style={{ height: "84vh" }}>
          <div className="px-8">
            <a className="mt-10  uppercase text-gray-200">{t("Menu")}</a>
          </div>

          {data?.map((route, index) =>
            route.sidebarProps ? (
              route.child ? (
                <SidebarItemCollapse item={route} key={index} />
              ) : (
                <SidebarItem item={route} key={index} />
              )
            ) : null
          )}
        </div>
      </div>
    </div>
  );
}

export default App;
